import { queryKeyFactory } from "@l2r-front/l2r-query"

export const NETWORKS_ROOT_QUERY_KEY = "networks"

export const networksQueryKeys = queryKeyFactory(NETWORKS_ROOT_QUERY_KEY, {
    referential: (networkSlug, filters) => [NETWORKS_ROOT_QUERY_KEY, "referential", networkSlug, filters] as const,
    roads: (networkSlug) => [NETWORKS_ROOT_QUERY_KEY, "roads", networkSlug] as const,
    features: (filters) => [NETWORKS_ROOT_QUERY_KEY, "features", filters] as const,
})
